import React from 'react';
import { useAuthContext } from '../../../features/auth/presentation/LoginAuthContext';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import './error.css';

const ErrorMessage = ({ status, message }) => {
  const { show_error } = useAuthContext();

  return (
    <section className={'errorMsg' + (status ? ' failed' : ' success')}>
      <AiOutlineCloseCircle
        style={{
          cursor: 'pointer',
          fontSize: '30px',
          right: '5px',
          top: '5px',
          lineHeight: '3em',
          paddingRight: '7px',
          float: 'right'
        }}
        onClick={() => {
          show_error('', false);
        }}
      />
      <p
        style={{
          paddingLeft: '30px',
          margin: '0.3rem auto',
          lineHeight: '107px',
          fontSize: '24px',
          fontFamily: 'SFDisplay'
        }}
      >
        {message}
      </p>
    </section>
  );
};
export default ErrorMessage;
